import React, { useCallback, useEffect, useState } from "react";
import { fmtMoney, parseMoney } from "../lib/mw";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { BrandMark } from "../components/Brand";
import { Phone, CheckCircle2, Camera } from "lucide-react";
import { shrinkImage } from "../lib/image";

const inp = "h-10 w-full rounded border border-slate-700 bg-slate-800 px-2 text-sm text-slate-100";
const tl = (n) => (Number(n) || 0).toLocaleString("tr-TR", { maximumFractionDigits: 2 });

function Card({ c, token, onDone }) {
  const d = c.data; const o = c.ops || {};
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ teslim_alan: "", tutar: o.ua_tutar || "", yontem: "NAKİT" });
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const done = o.teslim_durum === "TESLİM EDİLDİ";
  const [busy, setBusy] = useState(false);
  const [fotos, setFotos] = useState([]);
  const send = async () => {
    if (busy) return;
    if (!f.teslim_alan.trim()) { toast.error("TESLİM ALAN ADINI YAZIN"); return; }
    setBusy(true);
    try {
      await api.post(`/public/driver/${token}/deliver`, { data: { ...f, cargo_id: c.id } });
      for (const file of fotos) {
        const fd = new FormData(); fd.append("file", await shrinkImage(file, 1400, 0.8), "teslim.jpg");
        await api.post(`/public/driver/${token}/photo/${c.id}`, fd).catch(() => toast.error("FOTOĞRAF YÜKLENEMEDİ"));
      }
      toast.success(Number(f.tutar) > 0 ? "TESLİM + TAHSİLAT KASAYA DÜŞTÜ" : "TESLİM EDİLDİ"); setOpen(false); onDone();
    }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); onDone(); }
    setBusy(false);
  };
  return (
    <div data-testid={`drv-card-${c.id}`} className={`rounded-xl border p-3 ${done ? "border-emerald-700 bg-emerald-950/20" : "border-slate-700 bg-slate-900"}`}>
      <div className="flex items-center justify-between"><span className="font-mono text-xs text-sky-300">{d.takip_no}</span><span className="text-xs font-bold text-amber-300">{d.odeme || ""} {o.ua_tutar ? tl(o.ua_tutar) : ""}</span></div>
      <div className="text-base font-bold text-white">{d.alici_firma || d.sevk_musteri}</div>
      <div className="text-xs text-slate-400">{d.alici_adres} {d.alici_ilce} / {d.alici_il} · {d.adet} {d.koli_palet || d.birim}</div>
      {d.alici_tel && <a href={`tel:${d.alici_tel}`} className="mt-1 inline-flex items-center gap-1 text-xs text-sky-300"><Phone className="h-3 w-3" /> {d.alici_tel}</a>}
      {done ? <div data-testid={`drv-done-${c.id}`} className="mt-2 flex items-center gap-1 text-sm font-bold text-emerald-300"><CheckCircle2 className="h-4 w-4" /> TESLİM EDİLDİ {o.tahsil_durum ? "· " + o.tahsil_durum : ""}</div>
        : !open ? <button data-testid={`drv-open-${c.id}`} onClick={() => setOpen(true)} className="mt-2 h-11 w-full rounded-lg bg-emerald-600 text-sm font-bold text-white">TESLİM ETTİM</button>
        : <div className="mt-2 space-y-2">
            <input data-testid={`drv-alan-${c.id}`} placeholder="TESLİM ALAN AD SOYAD" value={f.teslim_alan} onChange={set("teslim_alan")} className={inp} />
            <div className="grid grid-cols-2 gap-2">
              <input data-testid={`drv-tutar-${c.id}`} inputMode="decimal" placeholder="TAHSİL (YOKSA BOŞ)" value={fmtMoney(f.tutar)} onChange={(e) => set("tutar")({ target: { value: parseMoney(e.target.value) } })} className={inp} />
              <select data-testid={`drv-yontem-${c.id}`} value={f.yontem} onChange={set("yontem")} className={inp}><option>NAKİT</option><option>HAVALE</option><option>ÇEK</option></select>
            </div>
            {f.yontem === "ÇEK" && <div className="grid grid-cols-2 gap-2">
              <input data-testid={`drv-cekno-${c.id}`} placeholder="ÇEK NO" onChange={set("cek_no")} className={inp} />
              <input placeholder="BANKA" onChange={set("cek_banka")} className={inp} />
              <input type="date" onChange={set("cek_vade")} className={inp} />
              <input placeholder="KEŞİDECİ" onChange={set("cek_sahibi")} className={inp} />
            </div>}
            <label data-testid={`drv-foto-label-${c.id}`} className="flex h-11 w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-dashed border-amber-600 text-sm font-bold text-amber-300">
              <Camera className="h-4 w-4" /> {fotos.length ? `${fotos.length} FOTOĞRAF SEÇİLDİ` : "TESLİMAT FOTOĞRAFI ÇEK"}
              <input data-testid={`drv-foto-${c.id}`} type="file" accept="image/*" capture="environment" multiple className="hidden" onChange={(e) => setFotos(Array.from(e.target.files || []))} />
            </label>
            <button data-testid={`drv-send-${c.id}`} disabled={busy} onClick={send} className="h-11 w-full rounded-lg bg-emerald-600 text-sm font-bold text-white disabled:opacity-50">{busy ? "KAYDEDİLİYOR..." : "ONAYLA"}</button>
          </div>}
    </div>
  );
}

export default function SurucuTeslim() {
  const { token } = useParams();
  const [d, setD] = useState(null); const [err, setErr] = useState("");
  const load = useCallback(() => api.get(`/public/driver/${token}`, { silent: true }).then((r) => setD(r.data)).catch(() => setErr("LİNK GEÇERSİZ")), [token]);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="driver-page" className="min-h-screen bg-slate-950 p-3 text-slate-100">
      {!err && <div className="mb-3 flex items-center gap-2">{d?.brand?.name && <BrandMark brand={d.brand} size={34} />}<div className="text-sm font-bold text-amber-300">{d?.brand?.name} · SÜRÜCÜ: {d?.surucu}</div></div>}
      {err && <div className="py-20 text-center text-slate-400">{err}</div>}
      {d && <div className="space-y-2">{d.items.length === 0 && <div className="py-10 text-center text-slate-500">ZİMMETLİ KARGO YOK</div>}{d.items.map((c) => <Card key={c.id} c={c} token={token} onDone={load} />)}</div>}
    </div>
  );
}
